import { render, staticRenderFns } from "./MasterAwbreceived.vue?vue&type=template&id=3b73001e&"
import script from "./MasterAwbreceived.vue?vue&type=script&lang=js&"
export * from "./MasterAwbreceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports